import Vue from 'vue'
import wizardVue from '../../../components/operations/line/connect/wizard.vue'

export default {
  wizard: function () {
    document.addEventListener('DOMContentLoaded', () => {
      new Vue({
        el: '#line_connect_wizard',
        render: h => h(wizardVue)
      })
    })
  }
}
